import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  // Lock body scroll when modal is open
  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [activeModal]);
  const closeModal = () => setActiveModal(null);
  return <footer className="bg-[#FAFAF7] border-t border-[#D4C5A9]/30 pt-16 pb-12 px-6" data-id="element-157">
      <div className="max-w-[720px] mx-auto text-center" data-id="element-158">
        <p className="text-[#2B4257] font-serif italic text-xl mb-8 leading-relaxed" data-id="element-159">
          "Run the 45-minute loop until the house stops arguing back."
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-[#5A5A5A] mb-6" data-id="element-160">
          <button onClick={() => setActiveModal('terms')} className="hover:text-[#2B4257] underline decoration-[#D4C5A9] underline-offset-4 transition-colors" data-id="element-161">
            Terms of Service
          </button>
          <button onClick={() => setActiveModal('privacy')} className="hover:text-[#2B4257] underline decoration-[#D4C5A9] underline-offset-4 transition-colors" data-id="element-162">
            Privacy Policy
          </button>
        </div>

        <p className="text-xs text-[#5A5A5A]/60" data-id="element-163">
          © {new Date().getFullYear()} Downsizing Without Regret. All rights
          reserved.
        </p>
      </div>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#2B4257]/40 backdrop-blur-sm" onClick={closeModal} data-id="element-164">
          <div className="bg-white w-full max-w-2xl max-h-[85vh] rounded-xl shadow-2xl overflow-hidden flex flex-col animate-in fade-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-id="element-165">
            {/* Modal Header */}
            <div className="flex justify-between items-center p-6 border-b border-[#D4C5A9]/30 bg-[#FAFAF7]" data-id="element-166">
              <h3 className="text-xl font-serif font-bold text-[#2B4257]" data-id="element-167">
                {activeModal === 'terms' ? 'Terms of Service' : 'Privacy Policy'}
              </h3>
              <button onClick={closeModal} className="p-2 text-[#5A5A5A] hover:text-[#2B4257] hover:bg-[#D4C5A9]/20 rounded-full transition-colors" aria-label="Close modal" data-id="element-168">
                <X className="w-5 h-5" data-id="element-169" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-8 overflow-y-auto text-[#5A5A5A] text-sm leading-relaxed space-y-4" data-id="element-170">
              {activeModal === 'terms' ? <>
                  <p data-id="element-171">
                    <strong data-id="element-172">1. Introduction</strong>
                    <br data-id="element-173" />
                    By purchasing "Downsizing Without Regret" (the "Product"),
                    you agree to these Terms of Service. The Product is a
                    digital download provided by Better by Steps.
                  </p>

                  <p data-id="element-174">
                    <strong data-id="element-175">2. Digital Product Policy</strong>
                    <br data-id="element-176" />
                    Due to the immediate nature of digital downloads, all sales
                    are final once the download link has been accessed. However,
                    if you have technical difficulties, please contact support
                    for assistance.
                  </p>

                  <p data-id="element-177">
                    <strong data-id="element-178">3. License for Personal Use</strong>
                    <br data-id="element-179" />
                    Your purchase grants you a non-exclusive, non-transferable
                    license to use the Product for personal, non-commercial
                    purposes. You may print copies for your own household use.
                  </p>

                  <p data-id="element-180">
                    <strong data-id="element-181">4. Intellectual Property</strong>
                    <br data-id="element-182" />
                    All content, designs, text, and graphics in the Product are
                    the intellectual property of Better by Steps. You may not
                    redistribute, resell, share, or copy the Product for others
                    without express written permission.
                  </p>

                  <p data-id="element-183">
                    <strong data-id="element-184">5. Disclaimer</strong>
                    <br data-id="element-185" />
                    The Product is for educational and informational purposes
                    only. It does not constitute professional legal, financial,
                    or psychological advice. Results may vary based on
                    individual circumstances.
                  </p>

                  <p data-id="element-186">
                    <strong data-id="element-187">6. Updates</strong>
                    <br data-id="element-188" />
                    We reserve the right to update these terms at any time.
                    Continued use of the Product constitutes acceptance of any
                    changes.
                  </p>
                </> : <>
                  <p data-id="element-189">
                    <strong data-id="element-190">1. Information Collection</strong>
                    <br data-id="element-191" />
                    We collect information you provide directly to us when you
                    make a purchase, such as your name, email address, and
                    payment information. We do not store credit card details on
                    our servers.
                  </p>

                  <p data-id="element-192">
                    <strong data-id="element-193">2. Use of Information</strong>
                    <br data-id="element-194" />
                    We use your information to deliver the Product, process
                    transactions, and send you important updates about your
                    purchase. We may also send you newsletters if you opt-in.
                  </p>

                  <p data-id="element-195">
                    <strong data-id="element-196">3. Cookies and Tracking</strong>
                    <br data-id="element-197" />
                    We use cookies to improve your browsing experience and
                    analyze site traffic. Third-party services like our payment
                    processors may also use cookies to function securely.
                  </p>

                  <p data-id="element-198">
                    <strong data-id="element-199">4. Third-Party Services</strong>
                    <br data-id="element-200" />
                    We use trusted third-party services for payment processing
                    (e.g., Stripe, PayPal) and email delivery. These services
                    have their own privacy policies which we encourage you to
                    review.
                  </p>

                  <p data-id="element-201">
                    <strong data-id="element-202">5. Data Security</strong>
                    <br data-id="element-203" />
                    We implement reasonable security measures to protect your
                    personal information. However, no method of transmission
                    over the Internet is 100% secure.
                  </p>

                  <p data-id="element-204">
                    <strong data-id="element-205">6. Contact Us</strong>
                    <br data-id="element-206" />
                    If you have questions about this Privacy Policy, please
                    contact us at support@betterbysteps.com.
                  </p>
                </>}
            </div>

            {/* Modal Footer */}
            <div className="p-4 border-t border-[#D4C5A9]/30 bg-[#FAFAF7] flex justify-end" data-id="element-207">
              <button onClick={closeModal} className="px-6 py-2 bg-[#2B4257] text-white font-semibold rounded-lg hover:bg-[#1f3040] transition-colors text-sm" data-id="element-208">
                Close
              </button>
            </div>
          </div>
        </div>}
    </footer>;
}